import React from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { PROJECT_COLOR, PROJECT_COLOR_DARK } from "../../../constants/colors";
import { useIsDesktop } from "../hooks/useIsDesktop";

/**
 * プロジェクト表示用の共通カードレイアウト
 *
 * - 左側に項番＋縦ラインを表示
 * - 上部アクセントバー付き
 * - 共通の背景・余白・影を適用
 * - children に任意のコンテンツを配置可能
 */
export default function ProjectNumberCard({ index, children, contentGap = 2 }) {
  const isDesktop = useIsDesktop();

  return (
    <Box
      sx={{
        // PC：左に番号エリア / 右にコンテンツ
        // SP：1カラム
        display: "grid",
        gridTemplateColumns: isDesktop ? "48px 1fr" : "1fr",
        gap: isDesktop ? 1.25 : 1,

        // カード共通装飾
        p: isDesktop ? 2 : 1.25,
        borderRadius: isDesktop ? 4 : 3,
        background:
          "linear-gradient(135deg, #F8F6FF 0%, #FFFFFF 45%, #F5F7FB 100%)",
        boxShadow: "0 8px 22px rgba(88, 80, 160, 0.1)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* 上部アクセントバー */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: 4,
          background: PROJECT_COLOR,
        }}
      />

      {/* 項番＋縦ライン（PCのみ表示） */}
      {isDesktop && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: 1,
          }}
        >
          {/* 項番 */}
          <Box
            sx={{
              width: 34,
              height: 34,
              border: `1.5px solid ${alpha(PROJECT_COLOR, 0.7)}`,
              borderRadius: 1.5,
              color: PROJECT_COLOR_DARK,
              fontWeight: 700,
              fontSize: 13,

              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              backgroundColor: "#fff",
              boxShadow: `0 2px 8px ${alpha(PROJECT_COLOR, 0.12)}`,
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: 13,
                lineHeight: 1,
              }}
            >
              {index}
            </Typography>
          </Box>

          {/* 縦ライン */}
          <Box
            sx={{
              flex: 1,
              borderLeft: `2px solid ${alpha(PROJECT_COLOR, 0.28)}`,
              mt: 0.75,
              minHeight: 28,
            }}
          />
        </Box>
      )}

      {/* コンテンツエリア */}
      <Box
        sx={{
          display: "grid",
          gap: isDesktop ? contentGap : 1.25,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
